import React, { Component, Fragment } from 'react';
import ProgressSteps from "./progressSteps";
import EnterNames from "./enterNames"
import SelectGrade from "./selectGrade"


class AddStudentsFlow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      yourX: this.props.yourX,
      currentStep: 1,  // 1 for add names, 2 for select grade
      studentsToAdd: [''],
      gradeText: 'K',
      grade: 'kindergarten'
    };
  }

  //////////////////////////////////////
  // Helper functions
  //////////////////////////////////////

  changeStep = (changeTo) => {
    this.setState({
      currentStep: changeTo
    });
  }

  moveFromNamesToSettings = (inputFields) => {
    // 1. Clean up user inputs and update list of names
    // 2. Go to the next page

    let cleanInputFields = inputFields.filter(value => (value.trim() !== ''));
    this.setState({
      studentsToAdd: [...cleanInputFields]
    }, () => this.changeStep(2))
  }

  selectGradeGoBack = (fields) => {
    this.setState({
      gradeText: fields.gradeText,
      grade: fields.grade
    })

    this.changeStep(1);
  }

  submitAddStudents = (fields) => {
    let data = {
      ...fields,
      names: [...this.state.studentsToAdd]
    };

    this.props.passNewStudentsToMyStudentsPage(data);
  }

  //////////////////////////////////////

  render() {
    let currentStepComponent;
    if (this.state.currentStep > 1) {
      currentStepComponent = <SelectGrade
        yourX={this.state.yourX}
        numStudentsToAdd={this.state.studentsToAdd.length}
        gradeText={this.state.gradeText}
        grade={this.state.grade}
        goBack={this.selectGradeGoBack}
        handleDone={this.submitAddStudents}
      />;
    } else {
      currentStepComponent = <EnterNames
        yourX={this.state.yourX}
        studentsToAdd={this.state.studentsToAdd}
        players={this.props.players}
        moveFromNamesToSettings={this.moveFromNamesToSettings}
        availableSeats={this.props.maxPlayers - Object.keys(this.props.players).length}
      />;
    }

    return (
      <Fragment>
        <div className="header-container">
          <ProgressSteps currentStep={this.state.currentStep} />
        </div>
        {currentStepComponent}
      </Fragment>
    );
  }
}

export default AddStudentsFlow;
